import { Link } from "react-router-dom";
import { Play, ArrowRight, Phone } from "lucide-react";
import SeoHead from "../components/SeoHead";
import CTABand from "../components/CTABand";
import { PageHeader } from "./Services";
import { SITE } from "../lib/site";

export const VIDEOS = [
  {
    src: "https://customer-assets.emergentagent.com/job_wonderful-greider-8/artifacts/y6yr44q0_2026-04-03-114323336.mp4",
    title: "Colonie de termites observée en Gironde",
    description:
      "Observation directe d'une colonie active de Reticulitermes flavipes sur bois infesté lors d'une expertise terrain en Bordeaux Métropole. Termites ouvriers blanchâtres en pleine activité dans les galeries.",
    date: "2026-04-03",
    location: "Bordeaux Métropole",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_wonderful-greider-8/artifacts/7n16wmvr_2026-04-07-150457022.mp4",
    title: "Bois infesté — termites en galerie",
    description:
      "Termites souterrains observés à découvert dans une pièce de bois colonisée. Les ouvriers circulent dans les galeries creusées à l'intérieur du bois, signe d'une infestation active.",
    date: "2026-04-07",
    location: "Gironde",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_wonderful-greider-8/artifacts/tqbl8biz_2026-05-15-181149462.mp4",
    title: "Dispositif de surveillance termites au sol",
    description:
      "Bois de surveillance posé au-dessus d'un point d'entrée souterrain : la colonie est venue consommer l'appât, signe d'une activité termites confirmée sur le périmètre du bâtiment.",
    date: "2026-05-15",
    location: "Gironde",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_wonderful-greider-8/artifacts/04668yhh_20241223_101952.mp4",
    title: "Forte infestation de termites — chantier décembre",
    description:
      "Très forte densité de termites visibles sur du bois fortement dégradé. Chantier d'expertise en Gironde révélant une colonie bien établie dans la structure.",
    date: "2024-12-23",
    location: "Gironde",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_wonderful-greider-8/artifacts/p4ig16hd_20250303_204822.mp4",
    title: "Bois contaminé par les termites — mars 2025",
    description:
      "Documentation d'un bois fortement attaqué par les termites lors d'une intervention en Gironde. Galeries internes et matière fragilisée mises en évidence avant traitement.",
    date: "2025-03-03",
    location: "Gironde",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_wonderful-greider-8/artifacts/ej6ii93p_20250407_160232.mp4",
    title: "Découverte d'une infestation termites en Gironde",
    description:
      "Mise au jour d'une colonie de termites lors d'une expertise. Le bois découvert présente des termites ouvriers visibles et un évidement caractéristique des galeries.",
    date: "2025-04-07",
    location: "Bordeaux Métropole",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_wonderful-greider-8/artifacts/kid4n5mh_20250815_094303.mp4",
    title: "Expertise terrain — bois infesté",
    description:
      "Examen d'un bois colonisé par des insectes xylophages lors d'une intervention en Gironde. Étape de repérage essentielle avant définition du protocole de traitement.",
    date: "2025-08-15",
    location: "Gironde",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_wonderful-greider-8/artifacts/qz7i3zs5_20260310_095559.mp4",
    title: "Termites souterrains en sortie de galerie",
    description:
      "Gros plan sur des termites Reticulitermes flavipes circulant à l'air libre après ouverture du bois colonisé. Comportement typique d'une colonie active.",
    date: "2026-03-10",
    location: "Bordeaux centre",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_wonderful-greider-8/artifacts/txarm309_20260312_103340.mp4",
    title: "Traces d'insectes xylophages sur panneau bois",
    description:
      "Petits trous et auréoles brunes typiques d'une attaque de xylophages (vrillettes, lyctus) sur un panneau bois en intérieur. Indices visuels d'une activité ancienne ou récente à confirmer par sondage.",
    date: "2026-03-12",
    location: "Gironde",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_wonderful-greider-8/artifacts/ydmj8qq0_20260331_104648.mp4",
    title: "Repérage termites — expertise de fin mars",
    description:
      "Bois colonisé par les termites observé lors d'une expertise réalisée fin mars en Gironde. Période classique d'activité avant l'essaimage printanier.",
    date: "2026-03-31",
    location: "Gironde",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_wonderful-greider-8/artifacts/spm4ahtm_20260403_091842.mp4",
    title: "Bois extérieur rongé — colonie au sol",
    description:
      "Morceaux de bois extérieurs entièrement parcourus de galeries et envahis de termites ouvriers. Un trou dans le sol à proximité trahit la présence d'une colonie souterraine.",
    date: "2026-04-03",
    location: "Gironde",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_wonderful-greider-8/artifacts/jx2nwm3a_20260515_122136.mp4",
    title: "Piège bois en périmètre — activité termites confirmée",
    description:
      "Vue rapprochée d'un piège bois placé au sol : les termites sortent par l'ouverture et consomment l'appât. Validation visuelle de la présence d'une colonie en périphérie du bâtiment.",
    date: "2026-05-15",
    location: "Gironde",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_wonderful-greider-8/artifacts/e80b27329aec3e9b_2026-06-30-190305865.mp4",
    title: "Galeries creusées — termites en pleine activité dans le bois",
    description:
      "Gros plan sur un morceau de bois entièrement rongé par les termites souterrains. Les ouvriers blanchâtres circulent activement dans les galeries, signe d'une colonie établie à proximité immédiate du bâtiment. Expertise Gironde — été 2026.",
    date: "2026-06-30",
    location: "Gironde",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_wonderful-greider-8/artifacts/8d8e05f102847e4f_2026-08-25-181639134.mp4",
    title: "Bois-appât consommé — pièges-appâts Termigard en action",
    description:
      "Vue d'une station d'appât périmétrique associée à un bois témoin au sol : les termites Reticulitermes consomment activement la cellulose du bois-appât. Validation terrain d'une colonie souterraine périphérique avant mise en matrice insecticide. Chantier Gironde — fin août 2026.",
    date: "2026-08-25",
    location: "Gironde",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_wonderful-greider-8/artifacts/11a143986f9ab8b0_2026-09-20-174317111.mp4",
    title: "Contrôle de station d'appât extérieure — rentrée 2026",
    description:
      "Inspection d'une station Termigard System en périmètre d'une propriété girondine : bois témoin visiblement attaqué, cavité circulaire prête à recevoir la matrice d'élimination. Suivi régulier pour protéger la bâtisse en continu. Expertise Gironde — septembre 2026.",
    date: "2026-09-20",
    location: "Gironde",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_wonderful-greider-8/artifacts/bd9409c08bc11ffb_20260630_113841.mp4",
    title: "Chantier de juin — intervention curative sur bois attaqué",
    description:
      "Prise de vue terrain lors d'une intervention curative : documentation d'un support bois attaqué par insectes xylophages avant mise en œuvre du protocole de traitement (bûchage, injection, pulvérisation). Chantier Gironde — fin juin 2026.",
    date: "2026-06-30",
    location: "Gironde",
  },
];

export default function Videos() {
  return (
    <div data-testid="videos-page">
      <SeoHead
        title="Vidéos chantiers termites Bordeaux & Gironde | Termite Bordeaux"
        description="16 vidéos réelles de chantiers termites filmées par notre équipe en Gironde (2024-2026) : colonies Reticulitermes en action, cordonnets, pièges-appâts Termigard consommés, charpentes attaquées, bûchage et traitements. Son coupé, lecture silencieuse."
        canonical={SITE.url + "/videos"}
        keywords={[
          "vidéo termites Bordeaux",
          "vidéo chantier termites",
          "termites filmés Bordeaux",
          "vidéo traitement termites Gironde",
        ]}
        breadcrumbs={[
          { name: "Accueil", url: SITE.url + "/" },
          { name: "Vidéos", url: SITE.url + "/videos" },
        ]}
        schema={{
          "@context": "https://schema.org",
          "@type": "ItemList",
          itemListElement: VIDEOS.map((v, i) => ({
            "@type": "VideoObject",
            position: i + 1,
            name: v.title,
            description: v.description,
            uploadDate: v.date,
            contentUrl: v.src,
            thumbnailUrl: SITE.url + "/brand/logo.png",
          })),
        }}
      />
      <PageHeader
        eyebrow="Vidéos chantiers"
        title="Voir les termites en action."
        intro="Vidéos filmées par notre équipe lors d'interventions réelles en Gironde. Termites, cordonnets, pièges-appâts, charpentes attaquées, traitements curatifs."
      />

      <section className="container-x py-12">
        <div className="grid md:grid-cols-2 gap-8">
          {VIDEOS.map((v, i) => (
            <article
              key={i}
              className="bg-white border border-[#D5CABD] rounded-sm overflow-hidden"
              data-testid={`video-card-${i}`}
            >
              <video
                src={v.src}
                muted
                playsInline
                controls
                preload="metadata"
                loop
                className="w-full aspect-video object-cover bg-black"
                aria-label={v.title}
              />
              <div className="p-5">
                <div className="text-[10px] uppercase tracking-widest text-[#7A2E39] mb-1">
                  {v.location} · {new Date(v.date).toLocaleDateString("fr-FR")}
                </div>
                <h2 className="font-serif text-xl text-gray-900 mb-2">{v.title}</h2>
                <p className="text-sm text-gray-700">{v.description}</p>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="container-x py-12 max-w-3xl text-center">
        <h2 className="font-serif text-3xl text-gray-900 mb-4">
          Vous voyez ces signes chez vous ?
        </h2>
        <p className="text-gray-700 mb-6">
          Si ces images vous rappellent une situation que vous observez à Bordeaux ou en Gironde,
          n'attendez pas. Demandez un devis personnalisé gratuit ou appelez-nous directement.
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          <Link to="/devis" className="btn-primary" data-testid="videos-devis">
            Demander un devis gratuit <ArrowRight className="w-4 h-4" />
          </Link>
          <a href={`tel:${SITE.phoneRaw}`} className="btn-ghost" data-testid="videos-call">
            <Phone className="w-4 h-4" /> {SITE.phone}
          </a>
        </div>
      </section>

      <CTABand />
    </div>
  );
}
